import { createAsyncThunk } from '@reduxjs/toolkit';
import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { ThunkAPI } from './ThunkAPI';

export function createAsyncThunkSafe<TActionReturn, TActionArgs>(type: string, asyncAction: (args: TActionArgs, thunkApi: ThunkAPI) => Promise<TActionReturn>) {
  assert_string_not_empty(type);

  return createAsyncThunk<TActionReturn, TActionArgs, ThunkAPI>(type, async (args: TActionArgs, thunkApi) => {
    // try {
    const result: Awaited<TActionReturn> = await asyncAction(args, thunkApi as unknown as ThunkAPI);
    return result;
    // } catch (error: unknown) {
    //   let errorMessage = 'An unknown error occurred';

    //   if (error instanceof Error) {
    //     errorMessage = error.message;
    //   } else if (typeof error === 'string') {
    //     errorMessage = error;
    //   } else if (error && typeof error === 'object' && 'message' in error) {
    //     errorMessage = String(error.message);
    //   }

    //   notification.error({
    //     message: type,
    //     description: errorMessage,
    //   });

    //   loge(error);
    //   // Revert the state to the previous state
    //   undo(0);

    //   return thunkApi.rejectWithValue(errorMessage);
    // }
  });
}
